export enum BUTTON_SIZE {
  DEFAULT = 'default',
  SMALL = 'small',
  LARGE = 'large'
}
